import { Pagination } from 'types'
import { CITIZEN_RELATION_INITIAL_PAGINATION } from '../citizens'

export const UNIFIED_PERSON_RELATION_INITIAL_PAGINATION: Pagination = CITIZEN_RELATION_INITIAL_PAGINATION

